import React, {useContext} from "react";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  makeStyles
} from "@material-ui/core";

import { apollo_useStyles } from "../../atom/Apollo_styles";

type ConfirmNotActiveDialogProps = {
  isExistsNotActiveAudience?: boolean,
  isExistsNotActiveSetPoint?: boolean,
  isExistsDeletedAudience?: boolean,
  isExistsDeletedSetPoint?: boolean,
  handleSave: any,
  handleClose: any,
}

export const dialogStyle = makeStyles({
  rowStyle: {
    marginTop: 20,
  },
});

export const ApolloConfirmNotActiveDialog = (props: ConfirmNotActiveDialogProps) => {
  const classes = apollo_useStyles();

  return (
    <React.Fragment>
      <DialogTitle>
        <Typography variant="subtitle1">
            確認
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {props.isExistsNotActiveSetPoint
            ? <>
              <Typography variant="body1">
                停止中の測定ポイントが設定されていますがよろしいでしょうか？
              </Typography>
              <Typography variant="body1" style={{"marginBottom":"20px"}}>
                ※停止中の測定ポイントは、効果測定対象外となりますのでご注意ください
              </Typography>
            </>
            : <></>}
          {props.isExistsNotActiveAudience
            ? <>
              <Typography variant="body1">
                停止中のオーディエンスが設定されていますがよろしいでしょうか？
              </Typography>
              <Typography variant="body1" style={{"marginBottom":"20px"}}>
                ※停止中のオーディエンスは、来訪ログなどの蓄積が停止しておりますのでご注意ください
              </Typography>
            </>
            : <></>}
          {props.isExistsDeletedSetPoint
            ? <>
              <Typography variant="body1" style={{"marginBottom":"20px"}}>
                削除済みの測定ポイントが設定されていますがよろしいでしょうか？
              </Typography>
            </>
            : <></>}
          {props.isExistsDeletedAudience
            ? <>
              <Typography variant="body1" style={{"marginBottom":"20px"}}>
                削除済みのオーディエンスが設定されていますがよろしいでしょうか？
              </Typography>
            </>
            : <></>}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          className={classes.button}
          onClick={async() => {
            props.handleClose();
            await props.handleSave();
          }}
          variant="contained"
        >
          実行
        </Button>
        <Button
          color="primary"
          className={classes.button}
          onClick={props.handleClose}
          variant="contained"
        >
          戻る
        </Button>
      </DialogActions>
    </React.Fragment>
  );
}
